// import React, {useState} from 'react';

// import {
//     Box,
//     Checkbox,
//     FormGroup,
//     FormControl,
//     FormControlLabel,
//     List,
//     ListItem,
//     ListItemText,
//     Slider
// } from '@mui/material';

// import SwipeableEdgeDrawer from 'components/SwipeableDrawer';

import React, { useState } from "react";
import {
  Box,
  Collapse,
  FormControl,
  List,
  ListItem,
  ListItemText,
  Typography,
  IconButton,
} from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import _ from "lodash";
function rangetext(value) {
  return `$${value}`;
}

const ResponsiveBgBox = (props) => (
  <>
    <Box sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
      {props.children}
    </Box>
    {/* <Box sx={{ display: { xs: 'block', sm: 'block', md: 'none' } }}>
            <SwipeableEdgeDrawer>
                {props.children}
            </SwipeableEdgeDrawer>
        </Box> */}
  </>
);

const RecursiveListItem = ({
  item,
  filter,
  openItems,
  handleToggle,
  level = 0,
}) => {
  const hasChildren = item.child && item.child.length > 0;
  const isSelected = filter.selectedItem === item.name;

  return (
    <>
      <ListItem
        button
        onClick={() => {
          if (filter.selectedItem === item.name) {
            filter.handleSelect(null);
          } else {
            filter.handleSelect(item.name);
          }

          if (hasChildren) {
            handleToggle(item.name);
          }
        }}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: isSelected
            ? level === 0
              ? "#f0f7ff"
              : "#e8f5e9"
            : level === 0
              ? "#F1F1F2"
              : "#fff",
          borderRadius: 2,
          mb: 1,
          px: 1,
          py: level === 0 ? 1.5 : 1,
          ml: level * 2, // Indent based on level
          cursor: "pointer",
          transition: "background-color 0.3s ease",
          "&:hover": {
            backgroundColor: "#f0f7ff",
          },
          ml: 0,
          p: { xs: "3px", md: "5px", lg: "8px" },
        }}
      >
        <ListItemText
          primary={item.name}
          primaryTypographyProps={{
            sx: {
              fontSize: {
                xs: level === 0 ? "0.75rem" : "0.70rem",
                md: level === 0 ? "0.80rem" : "0.80rem",
              },
              fontWeight: level === 0 ? 500 : 500,
              color: level === 0 ? "var(--color-black)" : "#666",
            },
          }}
        />
        {hasChildren && (
          <IconButton size="small">
            {openItems[item.name] ? (
              <ExpandLessIcon sx={{ color: "#000" }} />
            ) : (
              <ExpandMoreIcon sx={{ color: "#000" }} />
            )}
          </IconButton>
        )}
      </ListItem>

      {hasChildren && (
        <Collapse in={openItems[item.name]} timeout="auto" unmountOnExit>
          <List sx={{ pl: 0 }}>
            {item.child.map((child_item, idx) => (
              <RecursiveListItem
                key={idx}
                item={child_item}
                filter={filter}
                openItems={openItems}
                handleToggle={handleToggle}
                level={level + 1}
              />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
};

const DynamicFilter = ({ filterCategory }) => {
  const [openItems, setOpenItems] = useState({});

  // Handle toggle of submenus
  const handleToggle = (itemName) => {
    setOpenItems((prevState) => ({
      ...prevState,
      [itemName]: !prevState[itemName], // toggle the visibility of the submenu
    }));
  };

  return (
    <ResponsiveBgBox>
      <Box sx={{ p: 2, borderRadius: 1, maxWidth: "100%" }}>
        {filterCategory.map((filter, key) => (
          <Box
            key={key}
            mb={1}
            sx={{ borderBottom: "1px solid #e0e0e0", pb: 1 }}
          >
            <FormControl
              component="fieldset"
              variant="standard"
              sx={{ width: "100%" }}
            >
              <Typography
                variant="h4"
                gutterBottom
                sx={{
                  fontSize: { xs: "0.72rem", sm: "0.90rem", md: "1rem" },
                  fontWeight: 500,
                  color: "#000",
                  textTransform: "none",
                  mb: 1,
                }}
              >
                {filter.title}
              </Typography>

              <List>
                {filter.items.map((item, i) => (
                  <RecursiveListItem
                    key={i}
                    item={item}
                    filter={filter}
                    openItems={openItems}
                    handleToggle={handleToggle}
                  />
                ))}
              </List>
            </FormControl>
          </Box>
        ))}
      </Box>
    </ResponsiveBgBox>
  );
};

export default DynamicFilter;
